<template>
  <div>
    <date-picker
      v-model.trim="date"
      :icon="dateIcon"
      :label="dateLabel"
      :rules="rules"
      required
      :error-messages="errorMessages"
      :disabled="disabled"
    />
    <time-picker
      v-model.trim="time"
      :icon="timeIcon"
      :label="timeLabel"
      :rules="rules"
      :disabled="disabled"
      required
      :error-messages="errorMessages"
    />
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DateTimePicker',

  props: {
    dateLabel: String,
    timeLabel: String,
    disabled: Boolean,
    value: [String, Date, Number],
    rules: {
      type: Array,
      default () {return []}
    },
    errorMessages: {
      type: Array,
      default () {return []}
    },
    dateIcon: String,
    timeIcon: String,
    required: Boolean
  },

  data () {
    return {
      isActive: false,
      pickerValue: null
    }
  },

  computed: {
    parsedValue () {
      if (this.offsetFrom || Number.isInteger(this.pickerValue)) {
        // offset from offsetDate
        console.log('parseing offset', this.offsetFrom, this.pickerValue)
        return moment(this.offsetFrom).subtract(this.pickerValue || 0, 'day').format('YYYY-MM-DD')
      }
      // Assume it's a string date?
      return this.pickerValue
    },
    date: {
      get () {
        return this.pickerValue ? this.pickerValue.split(' ')[0] : null
      },
      set (val) {
        const time = this.time || '00:00:00'
        this.set(val + ' ' + time)
      }
    },
    time: {
      get () {
        return this.pickerValue ? this.pickerValue.split(' ')[1] : null
      },
      set (val) {
        const date = this.date || moment().format('YYYY-MM-DD')
        this.set(date + ' ' + val)
      }
    }
  },

  watch: {
    value (val) {
      if (this.pickerValue !== val) this.pickerValue = val
    }
  },

  mounted () {
    this.pickerValue = this.value
  },

  methods: {
    set (pickerDateTime) {
      this.pickerValue = pickerDateTime
      return this.$emit('input', pickerDateTime)
    }
  }
}
</script>
